import React from 'react'

export class Login extends React.Component {

  render() {
    return (
      <div>ログインしました</div>
    )
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/Login.js